import { useState } from "react";
import { Button } from "@/components/ui/button";
import { RefreshCw } from "lucide-react";
import { useToast } from "@/hooks/use-toast";
import { supabase } from "@/integrations/supabase/client";
import { useLanguage } from "@/contexts/LanguageContext";

interface ReprocessChatButtonProps {
  chatId: string;
  onReprocessComplete?: () => void;
}

export const ReprocessChatButton = ({ chatId, onReprocessComplete }: ReprocessChatButtonProps) => {
  const [reprocessing, setReprocessing] = useState(false);
  const { toast } = useToast();
  const { t } = useLanguage();

  const handleReprocess = async () => {
    setReprocessing(true);
    
    try {
      const { data, error } = await supabase.functions.invoke('reprocess-attachments', {
        body: { chatId }
      });

      if (error) throw error;

      if (data.success) {
        toast({
          title: t("toast.reprocessComplete") || "עיבוד מחדש הושלם",
          description: `נמצאו ${data.updatedCount} קבצים שלא זוהו קודם`,
        });
        
        // Reload the page to show updated data
        window.location.reload();
        
        onReprocessComplete?.();
      }
    } catch (error) {
      console.error('Reprocess error:', error);
      toast({
        title: t("toast.error") || "שגיאה",
        description: "נכשל עיבוד מחדש של הצ'אט",
        variant: "destructive",
      });
    } finally {
      setReprocessing(false);
    }
  };

  return (
    <Button
      variant="outline"
      size="sm"
      onClick={handleReprocess}
      disabled={reprocessing}
      className="gap-2"
    >
      <RefreshCw className={`w-4 h-4 ${reprocessing ? 'animate-spin' : ''}`} />
      {reprocessing ? "מעבד..." : "עיבוד מחדש של קבצים"}
    </Button>
  );
};
